import {
  ActiveModes,
  Addresses,
  CheckoutContactForm,
  OccCustomerConsignment,
  Options,
  PaymentMode,
  ReceiptType,
  TimeSlots,
} from '@checkout/const';
import { CustomOrder } from '@order/const';
import { Pos } from '@shop/const';
import { StateUtils } from '@spartacus/core';

export const CHECKOUT_FEATURE = 'checkout';
export const RECEIPT_TYPES = '[Checkout] Receipt types';
export const TIME_SLOTS = '[Checkout] Time slots';
export const SAVED_ADDRESS_LIST = '[Checkout] Saved address list';
export const USER_PICKUP_SHOP_LIST = '[Checkout] User pickup shop list';
export const OPTIONS = '[Checkout] Options';
export const PAYMENT_MODE_LIST = '[Checkout] Payment mode list';
export const CUSTOMER_CONSIGNMENT = '[Checkout] Customer Consignment';
export const PLACED_ORDER_PROCESS_ID = 'placeOrder';

export interface StateWithCustomCheckout {
  [CHECKOUT_FEATURE]: CustomCheckoutState;
}

export interface CustomCheckoutState {
  receiptType: StateUtils.LoaderState<ReceiptType[]>;
  activeModes: ActiveModes;
  timeSlots: StateUtils.LoaderState<TimeSlots>;
  addressList: StateUtils.LoaderState<Addresses>;
  userPickupShopList: StateUtils.LoaderState<Pos[]>;
  options: StateUtils.LoaderState<Options>;
  redirectedToPaymentPage: { value: boolean };
  orderDetails: CustomOrder;
  customerConsignment: StateUtils.LoaderState<OccCustomerConsignment>;
  paymentModeList: StateUtils.LoaderState<PaymentMode[]>;
}

export interface CustomCheckoutPersistence extends CustomCheckoutState {
  contactForm: CheckoutContactForm;
}
